import script from "./EditComment.vue?vue&type=script&setup=true&lang=js"
export * from "./EditComment.vue?vue&type=script&setup=true&lang=js"

import "./EditComment.vue?vue&type=style&index=0&id=2c0085ba&lang=scss"

const __exports__ = script;

export default __exports__